{
    "background": {
      "color": {
        "value": ""
      }
    },
    "fpsLimit": 60,
    "particles": {
      "number": {
        "value": 80,
        "density": {
          "enable": true,
          "area": 800
        }
      },
      "color": {
        "value": ["#ff0000", "#ffa500", "#ffff00", "#008000", "#0000ff", "#4B0082", "EE82EE"]
      },
      "shape": {
        "type": "char",
        "options": {
          "char": {
            "font": "Font Awesome 5 Free",
            "style": "",
            "weight": "900",
            "value": ["\uf004", "\uf005"]
          }
        }
      },
      "opacity": {
        "value": 0.8,
        "random": false,
        "anim": {
          "enable": true,
          "speed": 2,
          "opacity_min": 0.1,
          "sync": false
        }
      },
      "size": {
        "value": { "min": 10, "max": 40 },
        "random": true,
        "anim": {
          "enable": true,
          "speed": 20,
          "size_min": 10,
          "sync": false
        }
      },
      "move": {
        "enable": true,
        "speed": 2,
        "direction": "none",
        "random": false,
        "straight": false,
        "outModes": {
          "default": "out"
        },
        "attract": {
          "enable": false,
          "rotateX": 600,
          "rotateY": 1200
        }
      },
      "links": {
        "enable": false
      }
    },
    "interactivity": {
      "events": {
        "onHover": {
          "enable": false,
          "mode": "repulse"
        },
        "onClick": {
          "enable": true,
          "mode": "push"
        },
        "resize": true
      },
      "modes": {
        "grab": {
          "distance": 400,
          "line_linked": {
            "opacity": 1
          }
        },
        "bubble": {
          "distance": 400,
          "size": 40,
          "duration": 2,
          "opacity": 8,
          "speed": 3
        },
        "repulse": {
          "distance": 200,
          "duration": 0.4
        },
        "push": {
          "particles_nb": 4
        },
        "remove": {
          "particles_nb": 2
        }
      }
    },
    "retina_detect": true,
    "backgroundMask": {
      "enable": true,
      "cover": {
        "color": {
          "value": "#000000"
        },
        "opacity": 1
      }
    }
  }
  